import { RouteEnum } from 'app/shared/enums';

const isUnder = (pathname: string, route: string) =>
  pathname === route || pathname.startsWith(`${route}/`);

const NON_CAR_CALCULATOR_ROUTES = [
  RouteEnum.TRAVEL,
  RouteEnum.TERMINATION_GENERATOR,
  RouteEnum.PHINANCE_LEAD,
];

export const isCarCalculatorPath = (pathname: string) =>
  !NON_CAR_CALCULATOR_ROUTES.some((route) => isUnder(pathname, route));
